import type { IconData } from '@stacksjs/iconify-core'

export const room: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M440 424V88h-88V13.005L88 58.522V424H16v32h86.9L352 490.358V120h56v336h88v-32Zm-120 29.642l-200-27.586V85.478L320 51Z\"/><path fill=\"currentColor\" d=\"M256 232h32v64h-32z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default room
